<div class="card" style="min-height: calc(100vh - 9rem)">
  <app-header titulo="Variáveis" descricao="Variáveis cadastradas no PIMS e integrado ao sistema"></app-header>

  <div class="mt-3">
    <p-toolbar styleClass="mb-4 gap-2">
      <ng-template pTemplate="left">
        <p-button
          severity="success"
          label="Sincronizar"
          icon="pi pi-sync"
          [loading]="loading"
          loadingIcon="pi pi-sync"
          class="mr-2"
        (onClick)="sincronizarCadastros()"/>
      </ng-template>
    </p-toolbar>

    <p-tree class="w-full md:w-30rem" [value]="areas" emptyMessage="Nenhum registro encontrado"/>

  </div>

</div>


